module.exports = __webpack_public_path__ + "images/ellipses7fe6a385b78c3df5fefe32734cf703d5.svg";